import React, { useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from 'tss-react/mui';
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import ContentCopyIcon from "@mui/icons-material/ContentCopyOutlined";
import CheckIcon from "@mui/icons-material/CheckOutlined";

// A short value, such as a PIN, with a button that copies it.

const useStyles = makeStyles()((theme) => ({
  root: {
    display: "inline-flex",
    alignItems: "center",
    gap: 2,
    whiteSpace: "nowrap",
  },
  value: {
    fontSize: 15,
    fontWeight: 500,
    letterSpacing: "0.06em",
    fontVariantNumeric: "tabular-nums",
    color: theme.palette.text.primary,
  },
  empty: {
    color: theme.palette.text.disabled,
  },
  button: {
    color: theme.palette.text.secondary,
    opacity: 0.6,
    "&:hover, &:focus-visible": {
      opacity: 1,
    },
    "& svg": {
      fontSize: 16,
    },
  },
}));

const CopyValue = ({ value, label }) => {
  const { classes, cx } = useStyles();
  const [copied, setCopied] = useState(false);
  const text = value === null || value === undefined ? "" : String(value).trim();

  if (text === "") {
    return <span className={cx(classes.value, classes.empty)}>—</span>;
  }

  const copy = () => {
    if (!navigator.clipboard || !navigator.clipboard.writeText) return;
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1500);
    }).catch(() => {});
  };

  return (
    <span className={classes.root}>
      <span className={classes.value}>{text}</span>
      <Tooltip title={copied ? "Copied" : `Copy ${label || "value"}`}>
        <IconButton aria-label={`copy ${label || "value"}`} className={classes.button} size="small" onClick={copy}>
          {copied ? <CheckIcon /> : <ContentCopyIcon />}
        </IconButton>
      </Tooltip>
    </span>
  );
};

CopyValue.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string,
};

export default CopyValue;
